import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  id: string;
}

interface Result {
  sent: boolean;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/users/regenerate_and_resend_availability_link',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useRegenerateAndResendAvailabilityLinkLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useRegenerateAndResendAvailabilityLinkLazy;
